import { queryOptions } from '@tanstack/react-query';
import { fetchExchangeRate } from '../api/exchange-rate';
import { QUERY_KEYS, REFETCH_INTERVAL, STALE_TIMES } from '../../utils/constants';

/**
 * Query options factory for the exchange rate.
 * staleTime: 0 forces a fresh fetch on each mount.
 * refetchInterval: 0 disables automatic polling (set to a number in ms to enable).
 */
export const exchangeRateQueryOptions = () =>
  queryOptions({
    queryKey: QUERY_KEYS.exchangeRate,
    queryFn: fetchExchangeRate,
    staleTime: STALE_TIMES.exchangeRate,
    refetchInterval: REFETCH_INTERVAL.exchangeRate,
  });
